import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-4902de10"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "home-header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "logo-container"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  class: "logo"
}), /*#__PURE__*/_createElementVNode("h1", null, "压图")])], -1));
const _hoisted_3 = {
  class: "page-content"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "page-title"
}, "AI, 生产力工具导航站", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "page-description"
}, "选择您需要的工具开始使用,为设计师/开发者/运营者节省80%工具筛选时间", -1));
const _hoisted_6 = {
  class: "box-box"
};
const _hoisted_7 = {
  class: "search-container"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "tools-grid"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "tool-icon"
};
const _hoisted_12 = {
  class: "home-footer"
};
import { ref, computed } from 'vue';
import { Connection, VideoCameraFilled } from '@element-plus/icons-vue';
import CodeNav from '../codeindex/codeNav.vue';
import ImgNav from '../imageindex/imgNav.vue';
export default {
  __name: 'HomePage',
  setup(__props) {
    const navigateTo = url => {
      window.location.href = url;
    };

    // 定义工具列表
    const tools = [{
      title: "AI工具集",
      description: "AI工具导航，为您推荐各类实用的AI工具",
      url: "/ai.html",
      icon: Connection
    }, {
      title: "视频去水印",
      description: "各种短视频去水印，支持图文和短视频去水印",
      url: "/video.html",
      icon: VideoCameraFilled
    }];

    // 定义搜索查询和过滤后的工具列表
    const searchQuery = ref('');
    const filteredTools = computed(() => {
      if (searchQuery.value === '') {
        return tools;
      }
      return tools.filter(tool => {
        const titleMatch = tool.title.toLowerCase().includes(searchQuery.value.toLowerCase());
        const descriptionMatch = tool.description.toLowerCase().includes(searchQuery.value.toLowerCase());
        return titleMatch || descriptionMatch;
      });
    });
    return (_ctx, _cache) => {
      const _component_TrendCharts = _resolveComponent("TrendCharts");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("main", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_TrendCharts)]),
        _: 1
      }), _createTextVNode(" AI工具集 ")]), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchQuery.value = $event),
        type: "text",
        placeholder: "搜索",
        class: "search-input"
      }, null, 512), [[_vModelText, searchQuery.value]])]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTools.value, (tool, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "tool-card",
          onClick: $event => navigateTo(tool.url)
        }, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_icon, {
          is: tool.icon
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(tool.icon)))]),
          _: 2
        }, 1032, ["is"])]), _createElementVNode("h3", null, _toDisplayString(tool.title), 1), _createElementVNode("p", null, _toDisplayString(tool.description), 1)], 8, _hoisted_10);
      }), 128))])]), _createVNode(CodeNav), _createVNode(ImgNav)]), _createElementVNode("footer", _hoisted_12, [_createElementVNode("p", null, "© " + _toDisplayString(new Date().getFullYear()) + " 压图 . 保留所有权利.", 1)])]);
    };
  }
};